import styled from "styled-components";
// import { Link as LinkS } from "react-scroll";
import { Link as LinkR } from "react-router-dom";
import { motion } from 'framer-motion'

export const InfoContainer = styled(motion.div)`
  background: ${({ lightBg }) => (lightBg ? "#111111" : "#101522")};
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  overflow-x: hidden;
  padding: 0 60px;
  width: 100vw;
  height: 100vh;
  border-bottom: 2px solid #fff;

  @media screen and (max-width: 768px) {
    height: 100%;
    padding: 60px 0px;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 1400px;
  justify-content: space-evenly;
`;

export const InfoRow = styled.div`
  display: flex;
  width: 1100px;
  justify-content: space-between;
  flex-direction: ${({ imgStart }) => (imgStart ? "row-reverse" : "row")};

   @media screen and (max-width: 829px) {
    width: 100%;
    height: 100%;
    flex-direction: column;
    padding: 30px 0 0 0;
  }
`;

export const ColumnOne = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 500px;
  max-height: auto;
  @media screen and (max-width: 829px) {
    width: 100%;
    height: 100%;
    flex-direction: column;
    padding: 0 30px;
  }
`;

export const ColumnTwo = styled(motion.div)`
  display: flex;
  justify-content: center;
  max-width: 500px;
  max-height: auto;
  align-items: center;
`;

export const TextWrapper = styled.div`
    @media screen and (max-width: 768px) {
    padding-bottom: 0;
  }
`;

export const TopLine = styled.h3`
  color: ${({ lightTextTop }) => (lightTextTop ? "#2f5" : "#fff")};
  font-size: 16px;
  font-weight: 600;
`;

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 25px;
  font-weight: 600;
  color: ${({ lightText }) => (lightText ? "#2f5" : "#f7f8f9")};

  @media screen and (max-width: 768px) {
    font-size: 34px;
  }

  @media screen and (max-width: 480px) {
    font-size: 25px;
  }
`;

export const Subtitle = styled.p`
  margin-bottom: 35px;
  font-size: 18px;
  font-weight: 400;
  color: ${({ darkText }) => (darkText ? "#2f5" : "#fff")};
  @media screen and (max-width: 768px) {
    font-size: 24px;
  }

  @media screen and (max-width: 480px) {
    font-size: 18px;
  }
`;

export const BtnWrap = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const ImgWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px;
  max-width: 500px;
  max-height: auto;
  justify-content: ${({ start }) => (start ? "flex-start" : "flex-end")};

  @media screen and (max-width: 480px) {
    padding: 20px;
  }
`;

export const Img = styled.img`
  width: ${({ imgBig }) => (imgBig ? "450px" : "400px")};
  height: ${({ imgBig }) => (imgBig ? "450px" : "400px")};
  border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;
  object-fit: contain;
  @media screen and (max-width: 768px) {
    width: ${({ imgBig }) => (imgBig ? "200px" : "350px")};
    height: 250px;
  }
`;

export const ButtonInfo = styled(LinkR)`
  border-radius: 10px;
  background: ${({ primary }) => (primary ? "#2f5" : "#000")};
  white-space: nowrap;
  padding: ${({ big }) => (big ? "12px 48px" : "12px 30px")};
  color: ${({ dark }) => (dark ? "#2f5" : "#2f5")};
  font-size: ${({ fontBig }) => (fontBig ? "20px" : "16px")};
  outline: none;
  font-weight: bold;
  border: 1px solid #2f5;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.4s ease-in-out;

  &:hover {
    transition: all 0.4s ease-in-out;
    background: ${({ primary }) => (primary ? "#000" : "#2f5")};
    color: ${({ dark }) => (dark ? "#2f5" : "#000")};
  }
  @media screen and (max-width: 768px) {
    padding: ${({ big }) => (big ? "4px 12px" : "6px 15px")};
    color: ${({ dark }) => (dark ? "#000" : "#2f5")};
    font-size: ${({ fontBig }) => (fontBig ? "12px" : "14px")};
  }
`;
